import { AboutConatiner ,AboutH1, AboutImage} from './AboutElement'
import  img from '../../images/aboutme.jpg'

const About = () => {
    return (
      <AboutConatiner>
          <AboutH1>About me</AboutH1>
          <AboutImage src={img} alt={'altternative'} />
          <p>
          Professional chef with 10+ years of extensive experience in Vietname Cuisine.<br/>
          capable of managing dining sevice upto 100 tables while supervising and motivating staff<br/>
          to perform to best of thier ability <br/>
          </p>
          
      </AboutConatiner>
    )
}

export default About
